module.exports = __webpack_public_path__ + "img/micro-webserver.3ef2d9af.svg";